import { motion } from "framer-motion";
import "./revealTitle.css";

/**
 * Page-title mask reveal: each word slides up from behind a clip on mount.
 * Re-triggers whenever `text` changes (via key).
 */
export default function RevealTitle({ text, className = "", as = "h1" }) {
    const words = String(text).split(" ");
    const MotionTag = motion[as] || motion.h1;

    return (
        <MotionTag
            key={text}
            className={`revealTitle ${className}`}
            aria-label={text}
            initial="hidden"
            animate="visible"
            variants={{ visible: { transition: { staggerChildren: 0.09, delayChildren: 0.05 } } }}
        >
            {words.map((word, i) => (
                <span className="rt-word" key={i} aria-hidden="true">
                    <motion.span
                        className="rt-inner"
                        variants={{
                            hidden: { y: "115%" },
                            visible: { y: 0, transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] } },
                        }}
                    >
                        {word}
                    </motion.span>
                    {i < words.length - 1 ? " " : ""}
                </span>
            ))}
        </MotionTag>
    );
}
